import React from 'react';
import { useIntl } from 'ha/i18n';
import { makeStyles } from '@material-ui/core';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import { Button, Card, CardContent, Typography, units } from '@ha/dsl';
import { LinkToSearch } from 'ha/components.legacy/LinkToSearch';
import { ShortCountryData, ShortCityData } from 'ha/modules/Hermes/types';

const useStyles = makeStyles(() => ({
  title: {
    marginBottom: units.rem(0.5),
  },
}));

interface Props {
  city: ShortCityData;
  country: ShortCountryData;
}

const CTAFindRoom: React.FC<Props> = ({ city = {}, country = {} }) => {
  const { T } = useIntl();
  const classes = useStyles();
  return (
    <Card>
      <CardContent>
        <Typography.H2
          component="h2"
          className={classes.title}
          data-test-locator="Blog CTAFindRoom Title"
        >
          {T('blog_cta_find_room_title')}
        </Typography.H2>
        <Track name="Clicked CTA Find a room" type="link">
          <LinkToSearch
            city={city}
            country={country}
            data-test-locator="Blog CTAFindRoom Link"
          >
            <Button
              color="secondary"
              variant="contained"
              data-test-locator="Blog CTAFindRoom Button"
            >
              {city.name ? T('Find a room in %s', city.name) : T('Find a room')}
            </Button>
          </LinkToSearch>
        </Track>
      </CardContent>
    </Card>
  );
};

export { CTAFindRoom };
